export default "__VITE_ASSET__b3bad898__"